/** The life of one shift. Mirrors pkg/enums/StaffShiftState in the API. */
export enum StaffShiftState {
    /**
     * Not yet a promise. The rota read this portal makes never answers one — a draft
     * is enforced away on the server, not by a screen choosing not to draw rows — and
     * the value is here so that an unexpected one is still named rather than shown raw.
     */
    Draft = 'draft',

    Published = 'published',

    /**
     * Withdrawn after it was published. Still SHOWN, struck through: finding a shift
     * simply gone is worse than seeing it crossed out (docs/OSEBJE.md §12).
     */
    Cancelled = 'cancelled',
}

/** The modules a licence can carry, for the ones this portal has to ask about. */
export enum StaffModule {
    /**
     * "Zaposleni in čas" — the workforce module (docs/OSEBJE.md §14). This portal is
     * the face of `operations`, so `staff` is a licence it may or may not have beside
     * its own, and every screen that reads a staff route has to ask first.
     */
    Staff = 'staff',
}
